import { useEffect, useRef } from 'react';
import InkStroke from '../../../components/base/InkStroke';

export default function HeroSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    const timer = setTimeout(() => {
      el.style.transition = 'opacity 1s ease-out, transform 1s ease-out';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative h-[calc(100vh-72px)] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#4A3428]">
        <div className="absolute inset-0 bg-gradient-to-b from-amber/8 via-transparent to-deep-ink/20" />
      </div>

      <div
        ref={contentRef}
        className="relative z-10 text-center px-6 md:px-10 max-w-3xl mx-auto"
      >
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-parchment leading-tight tracking-tight-custom text-balance">
          built on trust, not theatre.
        </h1>

        <InkStroke className="mt-8 mb-8" />

        <p className="font-body text-sm md:text-base text-parchment/60 max-w-lg mx-auto leading-relaxed mb-10">
          We are a collective of experienced agency professionals — strategists, marketers, and operators — who work alongside your business to deliver real outcomes.
        </p>

        <button
          onClick={() => {
            const el = document.getElementById('contact');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex font-body text-sm font-semibold text-deep-ink bg-parchment px-8 py-3 rounded-md hover:bg-amber hover:text-parchment transition-colors duration-300 whitespace-nowrap cursor-pointer border-none"
        >
          Let&rsquo;s talk
        </button>
      </div>
    </section>
  );
}